export default __webpack_public_path__ + "static/LittlePrinceScholar-308549b0b33fed264dd53a4f7791637c.png";